import React from 'react';
import visaLogo from '../../../../assets/images/billing/visa-logo.png';
import mastercardLogo from '../../../../assets/images/billing/mastercard-logo.png';
import capitalize from '../../../../services/mini/capitalize';

function PaymentCardInfo({ expMonth, expYear, last4, brand, showCardName }) {
    return <div className="payment-card-info">
        {brand && <div className="payment-card-info__left-part">
            <div className="payment-card-info__card-type">
                {brand === 'visa' && <img src={visaLogo} />}
                {brand === 'mastercard' && <img src={mastercardLogo} />}
            </div>
            {showCardName && <div className="payment-card-info__card-name">{capitalize(brand)}</div>}
        </div>}
        <div className="payment-card-info__right-part">
            <div className="payment-card-info__last-4-digits">
                ****{last4}
            </div>
            <div className="payment-card-info__exp-date">
                {`${String(expMonth).padStart(2, '0')}/${String(expYear).substr(2, 4)}`}
            </div>
        </div>
    </div>;
}

export default PaymentCardInfo;